import classes from "./BlockTitle.module.css";
export const BlockTitle = ({ children }) => {
  return (
    <>
      <h2 className={classes.title}>{children}</h2>
    </>
  );
};
